import React from 'react';
import { useQuery } from 'react-apollo';
import gql from 'graphql-tag';
import { ID } from '@cinuru/utils/types';

export type ScreeningAttribute = {
	id: ID;
	label: string;
};

export const useAllScreeningAttributes = (): undefined | ScreeningAttribute[] => {
	const { data } = useQuery(
		gql`
			query AllScreeningAttributes {
				allScreeningAttributes {
					id
					label
				}
			}
		`
	);

	return React.useMemo(() => data?.allScreeningAttributes, [data?.allScreeningAttributes]);
};
